module.exports = __webpack_public_path__ + "arrow.svg?e1498c933718bed1dfbfd0172a46dd18";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow.svg
// module id = 530
// module chunks = 354